module.exports = __webpack_public_path__ + "static/img/zhongxiao_bg_02.32b8404.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zhongxiao_bg_02.png
// module id = c+0x
// module chunks = 0